import { boolean, object, string } from 'yup'

const KintoChangeNumberPlateSchema = object().shape({
  reg_num: string()
    .required('Current registration number is required')
    .matches(
      /(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
      'Current registration number is invalid',
    )
    .trim(),
  private_reg_num: string()
    .required('Private registration number is required')
    .matches(
      /(^[a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|(^[a-zA-Z][0-9]{1,3}[a-zA-Z]{3}$)|(^[a-zA-Z]{3}[0-9]{1,3}[a-zA-Z]$)|(^[0-9]{1,4}[a-zA-Z]{1,2}$)|(^[0-9]{1,3}[a-zA-Z]{1,3}$)|(^[a-zA-Z]{1,2}[0-9]{1,4}$)|(^[a-zA-Z]{1,3}[0-9]{1,3}$)|(^[a-zA-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
      'Private registration number is invalid',
    )
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone number is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  company_name: string()
    .matches(
      /^[A-Za-z0-9-.,'` ]{0,50}$/,
      'Company name can only contain letters and basic punctuation',
    )
    .max(50, 'Company name must be at most 50 characters')
    .trim(),
  retention_id: string()
    .required('Retention certificate is required')
    .max(50, 'Retention certificate must be at most 50 characters')
    .trim(),
  retention_postcode: string()
    .required('Postcode is required')
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    )
    .trim(),
  consent: boolean(),
})

export default KintoChangeNumberPlateSchema
